import { SET_TAIL_TYPE } from './types';

export const setTailType = tailType => ({ type: SET_TAIL_TYPE, tailType });
